import { trackPromise } from 'react-promise-tracker';

import { getJwt } from '@app/helpers';
import Axios from 'axios';

import { GetFileExtension, imageFormats } from './../helpers/index';
import api from './api';
import {
  getContratoOption,
  getContratoOptionExcetoEncerrados,
  getContratoOptionPorGestor,
  getContratosAtivosOption,
} from './dashboardContratos';
import { FormResponsaveisMrn } from '@app/views/Contrato/infoComplementar/panelResponsaveisFornecedorV2';

const controller = "contratos";

export interface Contrato {
  id: string;
  numero: number;
  status: string;
  situacao: boolean;
  fornecedor: string;
  gerirDocumentacaoAcessoria: boolean;
  urlAcessoDocumentacasoAcessorial: string;
}

export interface ContratoConsulta {
  id: string;
  numero: string;
  ccdigo: string;
  cnpj: string;
  nome: string;
  objetoResumido: string;
  status: string;
  sigla: string;
  tipoServico: string;
  localServico: string;
  localidade: string;
  diretoria: string;
  diretor: string;
  area: string;
  departamento: string;
  gerente: string;
  gestorMrn: string;
  emailGestorMrn: string;
  fiscalMrn: string;
  emailFiscalMrn: string;
  fiscalAlternativoMrn: string;
  tecnicoMedicao: string;
  administradorGpc: string;
  administradorAlternativoGpc: string;
  gestorFornecedor: string;
  emailGestorFornecedor: string;
  fiscalFornecedor: string;
  emailFiscalFornecedor: string;
  responsavel: string;
  emailResponsavel: string;
  emailFinanceiro: string;
  dataInicio: string;
  dadosIniciaisDataTermino: string;
  dadosIniciaisDataAtivacao: string;
  dadosIniciaisValor: string;
  quantidadeAditivos: string;
  valorTotalAditivos: string;
  dadosAtuaisDataTermino: string;
  dias: string;
  dadosAtuaisValor: string;
  condicaoPagamentoAtual: string;
  statusVigencia: string;
  frequencia: string;
  possuiSlaMonitorado: string;
  valorMedido: string;
  saldo: string;
  segurosEGarantias: string;
  qtdValido: string;
  qtdVencido: string;
  qtdAtencao: string;
  qtdProximoVencimento: string;
  qtdIgnorado: string;
  qtdFinalizado: string;
  enceramentoStatus: string;
  encerramentoTOTVS: string;
  trp: string;
  trd: string;
  nadaConsta: string;
  teqcAssinado: string;
  classificacaoServicoNivel1: string;
  classificacaoServicoNivel2: string;
  classificacaoServicoNivel3: string;
  possuiAnexoTratamentoDadosPessoais: string;
  isFaturamentoDireto: string;
}

export interface ContratoConsultaSimples {
  id: string;
  numero: string;
  nome: string;
  objetoResumido: string;
  status: string;
  diretoria: string;
  area: string;
  departamento: string;
  gestorMrn: string;
  fiscalMrn: string;
  gestorFornecedor: string;
  fiscalFornecedor: string;
  dataDeInicio: string;
  dadoInicialValor: string;
  quantidadeDeAditivos: string;
  valorTotalAditivos: string;
  dataDeTermino: string;
  dias: string;
  dadoAtualValor: string;
  valorMedido: string;
  saldo: string;
}

export interface ArquivosIniciaisDocontrato {
  id: string;
  contratoId: string;
  numero: number;
  nome: string;
  inclusao: string;
  responsavel: string;
}

export interface ContratoControleQAQC {
  id: string;
  numero: number;
  responsavelFornecedorNome: string;
  responsavelFornecedorNomeResumido: string;
  medicoes: any[];
}

export const getAllContratos = () => api.get<Contrato[]>('contratos');
export const createContrato = (contrato: Contrato) => {
  return api.post<Contrato>('contratos', contrato);
};
export const updateContrato = (contrato: Contrato) => api.put(`contratos/${contrato.id}`, contrato);
export const deleteContrato = (id: string) => api.delete(`contratos/${id}`);
export const activeContrato = (contratoId: string) => api.put(`contratos/ativarContrato/${contratoId}`);
export const deactiveContrato = (contratoId: string) => api.put(`contratos/desativarContrato/${contratoId}`);
export const GetTakeOfByContratoId = (id: string) => api.get(`contratos/GetTakeOfByContratoId/${id}`);
export const GetVerificarSeContratoEstaComStatusPreCadastradoByContratoId = (id: string) =>
  api.get<boolean>(`contratos/GetVerificarSeContratoEstaComStatusPreCadastradoByContratoId/${id}`);
export const creatDocumentoAcessoriaByContratoId = (id: string) =>
  api.post<any>(`contratos/creatDocumentoAcessoriaByContratoIdCommand/${id}`, id);
export const GetPesquisaContratoSimples = () =>
  api.get<ContratoConsultaSimples[]>(`contratos/GetPesquisaContratoSimples`);
export const getContratoDemandaInfo = (numero: string, demandaId:string, identificador: string | null = null) => api.get(`contratos/GetContratoDemandaInfo/${numero}/${demandaId}/${identificador}`);

export const ExportaRelatorioContratoSimple = () => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/contratos/getPesquisaContratoSimplesExportaExel`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorio_simples_contrato.xlsx');
      link.setAttribute('id', 'relatorio_simples_contrato');
      document.body.appendChild(link);
      link.click();
      document.getElementById('relatorio_simples_contrato').outerHTML = '';
    }),
  );
};

export const GetPesquisaContrato = () => api.get<ContratoConsulta[]>(`contratos/GetPesquisaContrato`);

export const ExportaRelatorioContrato = () => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/contratos/GetPesquisaContratoExportaExel`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorio_completo_contrato.xlsx');
      link.setAttribute('id', 'relatorio_completo_contrato');
      document.body.appendChild(link);
      link.click();
      document.getElementById('relatorio_completo_contrato').outerHTML = '';
    }),
  );
};

export const getAllArquivosIniciaisDoContrato = (id: string) =>
  api.get<ArquivosIniciaisDocontrato[]>(`contratos/getAllArquivosIniciaisDoContrato/${id}`);

export const excluirAquivoInicialDoContrato = (arquivoInicialId: string) =>
  api.delete(`contratos/excluirAquivoInicialDoContrato/${arquivoInicialId}`);

export const GetAquivoInicialDoContrato = (anexoId: string, nome: string) => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/contratos/getAquivoInicialDoContrato/${anexoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      link.setAttribute('id', 'downloadArquivoInicialContratoAnexo');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadArquivoInicialContratoAnexo').outerHTML = '';
    }),
  );
};

export const GetAquivoExportaHistoricoMedicao = (constratoId: string) => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/Medicao/getHistoricoMedicoes/${constratoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'historico_medicao.xlsx');
      link.setAttribute('id', 'downloadhistorico_medicao');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadhistorico_medicao').outerHTML = '';
    }),
  );
};

export const GetAquivoExportaHistoricoMedicaoCMG = (constratoId: string, pqId: string) => {
  const urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/Medicao/getHistoricoMedicoesCMG/${constratoId}/${pqId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'historico_medicao.xlsx');
      link.setAttribute('id', 'downloadhistorico_medicao');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadhistorico_medicao').outerHTML = '';
    }),
  );
};

export const getContratoOptionsForSelect = () =>
  getContratoOption().then(contrato =>
    (contrato || []).map(item => ({ text: item.descricaoContrato, value: item.id.toString() })),
  );

export const getContratoOptionExcetoEncerradosForSelect = () =>
  getContratoOptionExcetoEncerrados().then(contrato =>
    (contrato || []).map(item => ({ text: item.descricaoContrato, value: item.id.toString() })),
  );

export const getContratosAtivosOptionsForSelect = () =>
  getContratosAtivosOption().then(contrato =>
    (contrato || []).map(item => ({ text: item.descricaoContrato, value: item.id.toString() })),
  );

export const getContratoOptionsForSelectPorGestor = (id: string) =>
  getContratoOptionPorGestor(id).then(contrato =>
    (contrato || []).map(item => ({ text: item.descricaoContrato, value: item.id.toString() })),
  );

export const getContratoOptionsNumero = () =>
  getAllContratos().then(contrato => (contrato || []).map(item => ({ text: item.numero, value: item.id.toString() })));

export const VerificarSeUsuarioLogadoAdministradorDoContatoSessaoNumeroContrato = (numero: any) =>
  api.get<boolean>(`contratos/VerificarSeUsuarioLogadoAdministradorDoContatoSessaoNumeroContrato/${numero}`);

export const ViewArquivoInicialDoContrato = async (arquivoInicialId, nomeDoArquivo) => {
  const url = window.location.origin + `/api/contratos/getAquivoInicialDoContrato/${arquivoInicialId}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nomeDoArquivo);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) var resp = window.open(fileUrl);
  });
};

type GetContratoMultiplosGestoresResponse = {
  dados: FormResponsaveisMrn[];
};

export const getContratoMultiplosGestores = (contratoId: string) =>
  api.get<GetContratoMultiplosGestoresResponse>(`${controller}/${contratoId}/pq/contratoMultiplosGestores`);

export const putContratoMultiplosGestores = (contratoId: string, form: any) =>
  api.put(`${controller}/${contratoId}/pq/contratoMultiplosGestores`, form);

export const putContratoMultiplosGestoresFornecedores = (contratoId: string, form: any) =>
  api.put(`${controller}/${contratoId}/pq/contratoMultiplosGestoresFornecedores`, form);

export const putCreateUsuarioFornecedorContratoMultiplosGestoresFornecedores = (payload: any) =>
  api.post(`${controller}/createUserFornecedorByContrato`, payload);

export const GetContratoWithBM = (numeroContrato: string) => api.get<ContratoControleQAQC>(`contratos/GetContratoWithBM/${numeroContrato}`);